import './button.scss'

export default (props) => 
<button type={props.type || "button"} className={`button ${props.className} ${props.trailingIcon ? 'button-trailing-icon':''}`} style={props.style} onClick={props.onClick} disabled={props.disabled}>  
     
    {props.label || props.children}
    {props.trailingIcon && 
    <span className="icon-trailing">
        <span className={`icon`}
            style={{WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.trailingIcon}.svg)`, maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.trailingIcon}.svg)`, color:"currentColor"}}>
        </span>
    </span>}
</button>